var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 145.25 147.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    transform: "translate(-2.392 -1.93)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 71.625,
    cy: 72.719,
    rx: 71.625,
    ry: 72.719,
    transform: "translate(3.392 2.93)",
    fill: "none",
    stroke: "#0073E6",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M51.733,75.623V37.407c0-4.644,2.207-8.079,5.962-9.184a15.953,15.953,0,0,1,4.146-.238c1.885-.053,3.771.056,5.656.013,1.385-.031,2.774-.019,4.157-.02,3.244,0,6.485.015,9.729-.018,3.328-.034,6.657-.021,9.982.108,3.419.133,6.558,3.818,6.777,7.876.28,5.185.1,10.379.113,15.569q.039,24.767.012,49.535c0,4.1.008,8.191,0,12.287-.009,2.754-.492,5.317-2.265,7.347a6.966,6.966,0,0,1-5.306,2.635q-15.707.056-31.416.01c-4.231-.02-7.516-3.987-7.53-9-.027-9.677-.01-19.351-.012-29.025V75.623Zm2.723-4.051h-.007q0,15.768-.01,31.537c0,.828.145,1.2.963,1.195q19.539-.038,39.079,0c.814,0,1.1-.218,1.1-1.229q-.035-31.44,0-62.879c0-.978-.25-1.271-1.088-1.269q-19.412.042-38.827.027c-1.2,0-1.207.013-1.208,1.371Q54.454,55.948,54.456,71.572ZM74.9,120.195c5.247,0,10.493.018,15.741-.008,2.787-.014,4.883-2.461,4.918-5.7.023-2.063-.021-4.127.014-6.188.014-.76-.2-1.021-.858-1.006-1.748.039-3.5.017-5.246.015q-16.99,0-33.98-.02c-.792,0-1.078.258-1.05,1.2.055,1.869.123,3.75,0,5.605-.22,3.25,2.173,6.235,5.229,6.146C64.735,120.088,69.818,120.2,74.9,120.195ZM74.929,35.8q9.7,0,19.4,0c1.146,0,1.293-.249.758-1.456a4.875,4.875,0,0,0-4.633-3.291c-4.023-.012-8.047,0-12.071,0q-9.368,0-18.733,0a4.936,4.936,0,0,0-4.782,3.334c-.542,1.255-.435,1.417.747,1.417Q65.271,35.807,74.929,35.8Z",
    fill: "#0073E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M74.929,35.8q-9.657,0-19.315,0c-1.182,0-1.289-.163-.747-1.417a4.935,4.935,0,0,1,4.782-3.334q9.366,0,18.733,0c4.022,0,8.048-.01,12.071,0a4.875,4.875,0,0,1,4.633,3.291c.535,1.208.391,1.455-.758,1.456Q84.628,35.806,74.929,35.8Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M91.811,71.127a1.919,1.919,0,0,1-.547,1.375c-2.02,2.346-4.033,4.7-6.063,7.033-.706.813-1.5.877-2.063.238a1.751,1.751,0,0,1,.137-2.393q2.349-2.8,4.763-5.537c.448-.508.519-.833.024-1.388-1.574-1.764-3.1-3.585-4.642-5.391a4.854,4.854,0,0,1-.647-.87,1.55,1.55,0,0,1,.139-1.781,1.124,1.124,0,0,1,1.588-.321,2.671,2.671,0,0,1,.65.589q3.006,3.477,6,6.968A2.048,2.048,0,0,1,91.811,71.127Z",
    fill: "#0073E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M67.265,78.77a1.529,1.529,0,0,1-.74,1.277,1.183,1.183,0,0,1-1.541-.313c-.727-.8-1.427-1.627-2.134-2.447-1.375-1.594-2.755-3.184-4.119-4.792a1.767,1.767,0,0,1,.017-2.73q3.083-3.6,6.185-7.183c.695-.8,1.493-.9,2.06-.279a1.7,1.7,0,0,1-.169,2.444c-1.6,1.879-3.2,3.766-4.839,5.6-.53.593-.609.95-.027,1.589,1.592,1.751,3.115,3.588,4.669,5.385A2.182,2.182,0,0,1,67.265,78.77Z",
    fill: "#0073E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M78.859,61.91c1.041-.021,1.646,1.183,1.132,2.35-.392.886-.87,1.722-1.31,2.58q-3.08,6.024-6.158,12.049c-.1.195-.189.4-.3.578a1.26,1.26,0,0,1-1.832.514,1.634,1.634,0,0,1-.434-2.032c.75-1.579,1.549-3.128,2.34-4.68q2.607-5.115,5.227-10.22C77.826,62.453,78.176,61.914,78.859,61.91Z",
    fill: "#0073E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M75.022,114.645c-.914,0-1.827.021-2.739-.006a1.341,1.341,0,0,1-1.39-1.509,1.326,1.326,0,0,1,1.409-1.485q2.7-.036,5.394,0a1.4,1.4,0,0,1,1.418,1.5,1.431,1.431,0,0,1-1.438,1.5C76.793,114.665,75.906,114.646,75.022,114.645Z",
    fill: "#0073E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.7666d10156e85b1d5acb591643e710dc.svg";
export { ForwardRef as ReactComponent };